import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import { getToken } from "services/auth.service";
import { useAuthorization } from "./AuthorizationContext";

export default function PermissionGuard({
  children,
  permission,
  permissions,
  mode = "all",
  fallback = null,
  redirectTo = "/unauthorized",
}) {
  const { loading, error, authorization, refreshAuthorization, can, canAny, canAll } = useAuthorization();

  useEffect(() => {
    if (getToken() && !authorization && !loading && !error) {
      refreshAuthorization().catch(() => { /* Provider retains the error for display below. */ });
    }
  }, [authorization, loading, error, refreshAuthorization]);

  if (!getToken()) {
    return <Navigate to="/login" replace />;
  }

  if (error) {
    return <Box p={3}><Typography color="error">Không thể kiểm tra quyền truy cập. Hãy tải lại trang để thử lại.</Typography></Box>;
  }

  if (loading || !authorization) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px" flexDirection="column" gap={2}>
        <CircularProgress />
        <Typography variant="body2" color="text.secondary">
          Đang kiểm tra quyền truy cập...
        </Typography>
      </Box>
    );
  }

  const permissionList = permissions || (permission ? [permission] : []);
  const allowed =
    permissionList.length === 0
      ? true
      : mode === "any"
        ? canAny(permissionList)
        : permissionList.length === 1
          ? can(permissionList[0])
          : canAll(permissionList);

  if (!allowed) {
    return fallback || <Navigate to={redirectTo} replace />;
  }

  return children;
}
